export default __webpack_public_path__ + "static/media/SDG12.390f7e32.png";